import { Component } from '@angular/core';
import { Observable, map, takeWhile, tap, timer } from 'rxjs';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-auto-ml-entry',
  templateUrl: './auto-ml-entry.component.html',
  styleUrls: ['./auto-ml-entry.component.scss']
})
export class AutoMlEntryComponent {
   
  value:number=0
  constructor(
    public _autoMl:AutoMlService
  ){}

  ngOnInit(){
    
  }

}
